import { render, staticRenderFns } from "./refuse.vue?vue&type=template&id=4ee91a22&"
import script from "./refuse.vue?vue&type=script&lang=js&"
export * from "./refuse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports